module.exports = __webpack_public_path__ + "assets/img/icon_find.bfccf27c.svg";